import { motion } from 'framer-motion';
import { fadeUp } from './reveal';

// SECCIÓN 15 — FOOTER. Logo Emprendimiento Consciente (texto, sin asset) + legales.
export function S15Footer() {
  return (
    <section className="border-t border-white/10 bg-rc-black">
      <motion.footer {...fadeUp} className="mx-auto max-w-4xl px-4 py-12 text-center md:py-16">
        <p className="font-display text-2xl font-bold tracking-[0.25em] text-white uppercase">
          Emprendimiento
          <span className="block text-base font-semibold tracking-[0.45em]">Consciente</span>
        </p>

        <p className="mt-8 text-sm text-white/70">
          Copyright © 2019-2024, Emprendimiento Consciente - Todos los derechos reservados.
        </p>
        <p className="mt-2 text-sm text-white/70">
          Política de privacidad - Aviso legal - Política de cookies
        </p>
      </motion.footer>
    </section>
  );
}
